import axios from 'axios';

const API_URL = '/api/commands';

// 下发远程指令
// data: { licenseId, instanceId(可选, 空=全部实例), commandType: 'CLOSE_ALL'|'PAUSE'|'RESUME', ttlHours(可选) }
export const createCommand = async (data) => {
  try {
    const response = await axios.post(API_URL, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '下发指令失败' };
  }
};

// 指令列表(管理端)
export const getCommands = async (params = {}) => {
  try {
    const response = await axios.get(API_URL, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取指令列表失败' };
  }
};

// 取消排队中的指令
export const cancelCommand = async (id) => {
  try {
    const response = await axios.post(`${API_URL}/${id}/cancel`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '取消指令失败' };
  }
};
